<div class="container" [ngClass]="{ smallSize: currentStep === STEP1 }">
    <div class="header">
        <h4 class="title">
            {{ editMode ? ('repose-group.dialog.title.edit' | translate) : ('repose-group.dialog.title' | translate) }}
            <span class="text-mode-group-text" *ngIf="editMode">
                {{ ('repose-group.dialog.title.edit-group-text' | translate) + (data.groupNo + 1) }}
            </span>
        </h4>
        <button class="text-button" (click)="close()">
            {{ 'dlg.cancel' | translate }}
        </button>
    </div>
    <div class="step" *ngIf="currentStep === STEP1 && !isLoading">
        <div class="content-1">
            <div class="content-title">
                {{ 'repose-group.dialog.sub-title' | translate }}
            </div>
            <app-channel-text-input
                [name]="NAME_INPUT"
                [label]="'repose-group.dialog.label.name'"
                [placeholder]="'repose-group.dialog.label.name.placeholder'"
                [value]="data?.name"
                [maxLength]="32"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputError]="validationErrors?.name">
            </app-channel-text-input>
            <app-textarea-with-error
                class="input-form"
                [inputValue]="data?.description"
                legend="repose-group.dialog.label.description"
                [propertyName]="DESCRIPTION_INPUT"
                (onInputUpdated)="onTextAreaChange($event)"
                [validatorFunction]="validatorFunction()"
                [rows]="7"
                [maxLength]="25"
                [placeholder]="'repose-group.dialog.label.description.placeholder'"
            ></app-textarea-with-error>
        </div>
        <div class="footer" *ngIf="!editMode">
            <div class="step-text">
                {{ 'repose-group.dialog.step-1' | translate }}
            </div>
            <app-button
                [disable]="isStep1SaveButtonDisabled()"
                class="next-button"
                text="repose-group.dialog.next-button"
                customFontFamily="NotoSans-SemiBold"
                (onClick)="goNextStep()"
                [noneButtonPadding]="true"></app-button>
        </div>
        <div class="footer edit-mode" *ngIf="editMode">
            <div class="text-button" [class.disable]="isStep1SaveButtonDisabled()" (click)="goBackReview()">
                {{ 'repose-group.dialog.edit-mode.close-button' | translate }}
            </div>
            <app-button
                [disable]="isStep1SaveButtonDisabled()"
                class="next-button"
                text="repose-group.dialog.edit-mode.save-button"
                customFontFamily="NotoSans-SemiBold"
                (onClick)="editReposeGroup()"></app-button>
        </div>
    </div>
    <div class="step" *ngIf="currentStep === STEP2 && !isLoading">
        <div class="content-2">
            <div class="content-title">
                {{ 'repose-group.dialog.configuration.title' | translate }}
            </div>
            <span class="configuration-description">{{ 'repose-group.dialog.configuration.message' | translate }}</span>
            <button
                *ngIf="!assignedChannel"
                class="button search-channel-button"
                (click)="openSearchChannelDialog()"
                data-cy="repose-create-repose-group-select-channel-button">
                {{ 'repose-group.dialog.configuration.select-channel-button' | translate }}
            </button>
            <div class="channel-container" *ngIf="assignedChannel">
                <div class="channel">
                    <div class="channel-header">
                        <h6 class="channel-title">
                            {{ assignedChannel.opsData.name }}
                        </h6>
                        <span class="channel-type">
                            {{ assignedChannel.opsData.channelType }}
                        </span>
                    </div>
                    <div class="channel-content" *ngIf="!isDigitalChannel()">
                        <div class="range channel-measuring-range">
                            <span class="range-title">{{
                                'repose-group.dialog.title.measuring-range' | translate
                            }}</span>
                            <span class="range-value">{{ getMeasurableRangeStr() }}</span>
                        </div>
                        <div
                            *ngIf="assignedChannel.fcuData.normalRange.max || assignedChannel.fcuData.normalRange.min"
                            class="range channel-normal-range">
                            <span class="range-title">{{ 'repose-group.dialog.title.normal-range' | translate }}</span>
                            <span class="range-value">{{ getNormalRangeStr() }}</span>
                        </div>
                        <div
                            *ngIf="assignedChannel.fcuData.alarmSettingVeryHigh.enable"
                            class="range channel-high-high-range">
                            <span class="range-title">{{ 'repose-group.dialog.title.high-high' | translate }}</span>
                            <span class="range-value">{{ getAlarmRangeStr('alarmSettingVeryHigh') }}</span>
                        </div>
                        <div *ngIf="assignedChannel.fcuData.alarmSettingHigh.enable" class="range channel-high-range">
                            <span class="range-title">{{ 'repose-group.dialog.title.high' | translate }}</span>
                            <span class="range-value">{{ getAlarmRangeStr('alarmSettingHigh') }}</span>
                        </div>
                        <div *ngIf="assignedChannel.fcuData.alarmSettingLow.enable" class="range channel-high-range">
                            <span class="range-title">{{ 'repose-group.dialog.title.low' | translate }}</span>
                            <span class="range-value">{{ getAlarmRangeStr('alarmSettingLow') }}</span>
                        </div>
                        <div
                            *ngIf="assignedChannel.fcuData.alarmSettingVeryLow.enable"
                            class="range channel-low-low-range">
                            <span class="range-title">{{ 'repose-group.dialog.title.low-low' | translate }}</span>
                            <span class="range-value">{{ getAlarmRangeStr('alarmSettingVeryLow') }}</span>
                        </div>
                        <div
                            *ngIf="assignedChannel.fcuData.alarmSettingFeedbackError.enable"
                            class="range channel-high-high-range">
                            <span class="range-title">{{ 'repose-group.dialog.title.feedback' | translate }}</span>
                            <span class="range-value">{{ getAlarmRangeStr('alarmSettingFeedbackError') }}</span>
                        </div>
                    </div>
                    <div class="channel-footer">
                        <button class="text-button not-padding" (click)="openSearchChannelDialog()">
                            {{ 'repose-group.dialog.configuration.change-channel-button' | translate }}
                        </button>
                    </div>
                </div>
                <div class="non-digital" *ngIf="!isDigitalChannel()">
                    <div class="condition-description">
                        {{ 'repose-group.dialog.condition.description' | translate }}
                    </div>
                    <div class="segmented-control">
                        <div
                            class="segment"
                            [class.selected]="nonDigitalDataType === NON_DIGITAL_FLAG_VALUE"
                            (click)="setNonDigitalDataType(NON_DIGITAL_FLAG_VALUE)"
                            data-cy="repose-create-repose-group-value-button">
                            <mat-icon
                                class="icon"
                                svgIcon="check"
                                *ngIf="nonDigitalDataType === NON_DIGITAL_FLAG_VALUE"></mat-icon>
                            {{ 'repose-group.dialog.data-type.value' | translate }}
                        </div>
                        <div
                            class="segment"
                            [class.selected]="nonDigitalDataType === NON_DIGITAL_STATUS"
                            (click)="setNonDigitalDataType(NON_DIGITAL_STATUS)"
                            data-cy="repose-create-repose-group-status-button">
                            <mat-icon
                                class="icon"
                                svgIcon="check"
                                *ngIf="nonDigitalDataType === NON_DIGITAL_STATUS"></mat-icon>
                            {{ 'repose-group.dialog.data-type.status' | translate }}
                        </div>
                    </div>
                    <div class="segmented-control" *ngIf="nonDigitalDataType === NON_DIGITAL_FLAG_VALUE">
                        <div
                            class="segment"
                            [class.selected]="nonDigitalValueFlag === NON_DIGITAL_VALUE_FLAG_EXCEED"
                            (click)="setNonDigitalValueFlag(NON_DIGITAL_VALUE_FLAG_EXCEED)">
                            <mat-icon class="icon visible" svgIcon="exceed"></mat-icon>
                            {{ 'repose-group.dialog.value-flag.exeeds' | translate }}
                        </div>
                        <div
                            class="segment"
                            [class.selected]="nonDigitalValueFlag === NON_DIGITAL_VALUE_FLAG_FALL"
                            (click)="setNonDigitalValueFlag(NON_DIGITAL_VALUE_FLAG_FALL)">
                            <mat-icon class="icon visible" svgIcon="fall"></mat-icon>
                            {{ 'repose-group.dialog.value-flag.falls' | translate }}
                        </div>
                    </div>
                    <div
                        class="select-input-container"
                        *ngIf="nonDigitalDataType === NON_DIGITAL_STATUS"
                        (click)="showDropDown($event); $event.stopImmediatePropagation()"
                        [class.focus]="isShowDropDown">
                        <input
                            class="select-input"
                            [value]="selectedAlarmDropDownItem?.name | translate"
                            [placeholder]="
                                data?.nonDigitalAlarm
                                    ? ''
                                    : ('repose-group.dialog.select-input.alarm.placeholder' | translate)
                            "
                            readonly
                            data-cy="repose-create-repose-group-alarm-status" />
                        <mat-icon class="arrow" [class.focus]="isShowDropDown" svgIcon="dropdown-arrow" />
                        <div #listContainer *ngIf="isShowDropDown" class="item-list">
                            <div
                                class="item"
                                [class.disabled]="
                                    index === 0
                                        ? disabledNormalRange()
                                        : !assignedChannel.fcuData[item.propertyName]?.enable
                                "
                                *ngFor="let item of alarmDropDownList; let index = index"
                                (click)="selectAlarmItem(item)"
                                data-cy="repose-create-repose-group-alarm-status-item">
                                <mat-radio-button [checked]="data?.nonDigitalAlarm === item.propertyName">{{
                                    setNormalAlarmItemName(item, index)
                                }}</mat-radio-button>
                                {{ item.setPoint ? item.setPoint + assignedChannel.opsData.measurementUnit : '' }}
                            </div>
                        </div>
                    </div>
                    <app-channel-text-input
                        *ngIf="nonDigitalDataType && nonDigitalValueFlag"
                        [name]="SETPOINT"
                        label="repose-group.dialog.label.input-value"
                        [placeholder]="'repose-group.dialog.label.input-value.placeholder'"
                        type="number"
                        [value]="data?.setPoint"
                        (onInputChange)="onInputChange($event)"
                        (onFocusChange)="onInputChange($event)"
                        [inputError]="validationErrors?.setPoint"
                        [unit]="assignedChannel?.opsData?.measurementUnit"
                        (onInputKeyDown)="validInputValueKeyDown($event)">
                    </app-channel-text-input>
                    <div class="condition-description" *ngIf="data?.setPoint || selectedAlarmDropDownItem?.name">
                        {{ 'repose-group.dialog.delay.description' | translate }}
                    </div>
                    <div class="delay-container" *ngIf="data?.setPoint || selectedAlarmDropDownItem?.name">
                        <div class="delay-wrapper">
                            <app-channel-text-input
                                [name]="START_DELAY"
                                label="repose-group.dialog.label.start-delay"
                                type="number"
                                [value]="data?.startDelay"
                                (onInputChange)="onInputChange($event)"
                                (onFocusChange)="onInputChange($event)"
                                (onInputKeyDown)="validDelayKeyDown($event)"
                                [unit]="DELAY_UNIT">
                            </app-channel-text-input>
                        </div>
                        <div class="delay-wrapper">
                            <app-channel-text-input
                                [name]="STOP_DELAY"
                                label="repose-group.dialog.label.end-delay"
                                type="number"
                                [value]="data?.stopDelay"
                                (onInputChange)="onInputChange($event)"
                                (onFocusChange)="onInputChange($event)"
                                (onInputKeyDown)="validDelayKeyDown($event)"
                                [unit]="DELAY_UNIT">
                            </app-channel-text-input>
                        </div>
                    </div>
                </div>
                <div class="digital" *ngIf="isDigitalChannel()">
                    <app-channel-select-input
                        [name]="CHANNEL_STATUS"
                        label="repose-group.dialog.select-input.digital.status"
                        [value]="
                            data?.digitalChannelStatus == '0'
                                ? assignedChannel.fcuData.digitalAlarmSetting.statusStringContactOff
                                : data?.digitalChannelStatus == '1'
                                  ? assignedChannel.fcuData.digitalAlarmSetting.statusStringContactOn
                                  : ''
                        "
                        (inputChange)="onInputChange($event)"
                        [itemList]="[
                            assignedChannel.fcuData.digitalAlarmSetting.statusStringContactOn,
                            assignedChannel.fcuData.digitalAlarmSetting.statusStringContactOff,
                        ]"></app-channel-select-input>
                    <div
                        class="condition-description"
                        *ngIf="data?.digitalChannelStatus == '0' || data?.digitalChannelStatus == '1'">
                        {{ 'repose-group.dialog.delay.description' | translate }}
                    </div>
                    <div
                        class="delay-container"
                        *ngIf="data?.digitalChannelStatus == '0' || data?.digitalChannelStatus == '1'">
                        <div class="delay-wrapper">
                            <app-channel-text-input
                                [name]="START_DELAY"
                                label="repose-group.dialog.label.start-delay"
                                type="number"
                                [value]="data?.startDelay"
                                (onInputChange)="onInputChange($event)"
                                (onFocusChange)="onInputChange($event)"
                                (onInputKeyDown)="validDelayKeyDown($event)"
                                [unit]="DELAY_UNIT">
                            </app-channel-text-input>
                        </div>
                        <div class="delay-wrapper">
                            <app-channel-text-input
                                [name]="STOP_DELAY"
                                label="repose-group.dialog.label.end-delay"
                                type="number"
                                [value]="data?.stopDelay"
                                (onInputChange)="onInputChange($event)"
                                (onFocusChange)="onInputChange($event)"
                                (onInputKeyDown)="validDelayKeyDown($event)"
                                [unit]="DELAY_UNIT">
                            </app-channel-text-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer" *ngIf="!editMode">
            <div class="step-text">
                {{ 'repose-group.dialog.step-2' | translate }}
            </div>
            <div class="button-container">
                <button class="text-button" (click)="backStep1()">
                    {{ 'repose-group.dialog.back-button' | translate }}
                </button>
                <app-button
                    [disable]="
                        isDigitalChannel()
                            ? data?.digitalChannelStatus === ''
                            : nonDigitalDataType === NON_DIGITAL_FLAG_VALUE
                              ? validationErrors?.setPoint?.message
                              : !data?.nonDigitalAlarm
                    "
                    text="repose-group.dialog.create-button"
                    customFontFamily="NotoSans-SemiBold"
                    size="small"
                    customFontSize="14px"
                    (onClick)="createReposeGroup()"></app-button>
            </div>
        </div>
        <div class="footer edit-mode" *ngIf="editMode">
            <div class="text-button" (click)="goBackReview()" *ngIf="!disableGoBack">
                {{ 'repose-group.dialog.edit-mode.close-button' | translate }}
            </div>
            <app-button
                [disable]="
                    isDigitalChannel()
                        ? data?.digitalChannelStatus === ''
                        : nonDigitalDataType === NON_DIGITAL_FLAG_VALUE
                          ? validationErrors?.setPoint?.message
                          : !data?.nonDigitalAlarm
                "
                class="next-button"
                text="repose-group.dialog.edit-mode.save-button"
                customFontFamily="NotoSans-SemiBold"
                (onClick)="editReposeGroup()"></app-button>
        </div>
    </div>

    <div *ngIf="isLoading" class="loading-container">
        <app-loading-spinner [custom]="true" class="spinner-component" size="80" strokeWidth="3"></app-loading-spinner>
    </div>
</div>
